import { useLayoutEffect } from "react";
import { Navigate } from "react-router-dom";
import { useSettingsHub } from "@/shell/settings-hub";

/** 예전 주소는 설정 로그로 연다. */
export function SystemLogsPage() {
  useLayoutEffect(() => {
    useSettingsHub.getState().open("app", "logs");
  }, []);
  return <Navigate to="/" replace />;
}
